// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback-content[data-v-21583a06]{max-width:900px}ul[data-v-21583a06],ol[data-v-21583a06]{padding-left:20px}ul ul[data-v-21583a06]{margin-top:4px;padding-left:16px}", ""]);
// Exports
module.exports = exports;
